<template>
<div style="position:fixed;left: 0;top: 0;background: #fff;z-index:999;">
</div>
  <div :class="[classObj,sideTheme]" class="app-wrapper" :style="{ '--current-color': theme }">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar v-if="!sidebar.hide" class="sidebar-container"/>
    <div :class="{ hasTagsView: needTagsView, sidebarHide: sidebar.hide }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar @setLayout="setLayout"/>
        <tags-view v-if="needTagsView"/>
      </div>
      <app-main/>
      <settings ref="settingRef"/>
    </div>
    <!--  通讯录信息卡  -->
    <PopperUserInfo ref="contactPopRef" v-model="visibleContactPop" :temp-ref="contactTemRef"/>
  </div>
</template>

<script setup>
import {useWindowSize} from '@vueuse/core'
import Sidebar from './components/Sidebar/index.vue'
import {AppMain, Navbar, Settings, TagsView} from './components'
import {storeToRefs} from 'pinia'

import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'
import useContactUserStore from '@/store/modules/contact-user.js'

const PopperUserInfo = defineAsyncComponent(() => import('@/components/PopperUserInfo.vue'))

const settingsStore = useSettingsStore()
const theme = computed(() => settingsStore.theme)
const sideTheme = computed(() => settingsStore.sideTheme)
const sidebar = computed(() => useAppStore().sidebar)
const device = computed(() => useAppStore().device)
const needTagsView = computed(() => settingsStore.tagsView)
const fixedHeader = computed(() => settingsStore.fixedHeader)

const contactStore=useContactUserStore()
const { contactPopRef,visibleContactPop,
  contactTemRef } = storeToRefs(contactStore)
const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
  mobile: device.value === 'mobile'
}))

const {width, height} = useWindowSize()
const WIDTH = 992 // refer to Bootstrap's responsive design

watchEffect(() => {
  if (device.value === 'mobile' && sidebar.value.opened) {
    useAppStore().closeSideBar({withoutAnimation: false})
  }
  if (width.value - 1 < WIDTH) {
    useAppStore().toggleDevice('mobile')
    useAppStore().closeSideBar({withoutAnimation: true})
  } else {
    useAppStore().toggleDevice('desktop')
  }
})


function handleClickOutside() {
  useAppStore().closeSideBar({withoutAnimation: false})
}

const settingRef = ref(null)

function setLayout() {
  settingRef.value.openSetting()
}

// 路由更新时触发，确保能跳转到指定页面，实验性质，稳定好删除注释 todo
onBeforeRouteUpdate((to,from,next)=>{
  console.log('路由更新',to,from)
  next()
})
</script>

<style lang="scss" scoped>
//@import "@/assets/styles/mixin.scss";
//@import "@/assets/styles/variables.module.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  width: calc(100% - var(--base-sidebar-width));
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - var(--base-sidebar-width));
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}
</style>
